import { useSelector } from 'react-redux';
import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as assetFullSelectors from 'pages/asset-full-view/controllers/selectors';
import { useMutation } from '@tanstack/react-query';

import * as services from 'services/assetProduct';

export const useGetAssetList = () => {
  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const assetData = useSelector(assetFullSelectors.assetDataLoading());

  return selectedItemDetailList?.length > 0
    ? selectedItemDetailList
    : assetData
    ? [assetData]
    : [];
};

export const useFetchAssetProductIxOneCert = () => {
  return useMutation({
    mutationFn: async (assetIds) => {
      try {
        const response = await services.getProductIxoneCerByAsset(assetIds);
        if (response?.isSuccess) return response?.data;
        else return [];
      } catch (error) {
        console.error('error: ', error);
      }
    },
  });
};
